import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What types of steel pipes and tubes do you supply?",
    a: "We supply a wide range including MS Round Pipes, GI Pipes & Tubes, ERW Steel Tubes, Seamless Pipes, Square & Rectangular Hollow Sections, and Scaffolding Pipes. We also stock fittings, flanges, and valves.",
  },
  {
    q: "Do you deliver across India?",
    a: "Yes, we deliver pan-India with a strong network covering Tamil Nadu, Kerala, Karnataka, Maharashtra, and beyond. We ensure timely dispatch for both small and bulk orders.",
  },
  {
    q: "How can I get a price quote?",
    a: "You can request a quote through our website's Request Quote form, call us at +91 9894105887 / +91 8667353008, or email tahersteelenquiry@gmail.com with your requirements.",
  },
  {
    q: "Are your products ISI-certified?",
    a: "Yes, all our materials are ISI-certified and sourced from trusted, reliable manufacturers who meet stringent industry quality standards.",
  },
  {
    q: "Do you offer fire safety solutions?",
    a: "Yes, we provide complete fire safety systems including fire detection, alarm, sprinkler, and hydrant systems — covering supply, installation, testing, and AMC.",
  },
  {
    q: "What is the minimum order quantity?",
    a: "We cater to both small and bulk requirements. There is no strict minimum order — contact us with your needs and we'll work out the best solution for you.",
  },
];

export const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: f.a,
    },
  })),
};

const FAQ = () => (
  <section className="py-20 md:py-28 bg-background">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-accent-strong font-display text-sm uppercase tracking-[0.2em] mb-2">
            Common Questions
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left text-foreground font-body">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-body">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQ;
